import * as React from "react";
import PropTypes from "prop-types";
import Box       from "@mui/material/Box";
import Divider   from "@mui/material/Divider";
import Stack     from "@mui/material/Stack";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import GTranslateIcon    from "@mui/icons-material/GTranslate";
import Typography    from "@mui/material/Typography";
import { Text } from "@base";

/* ---------------------------------------------------------------
   Full-width Import / Export header (matches simplified page)
   --------------------------------------------------------------- */
export default function ImportHeader({ title, subHeader, children }) {
  return (
    <>
      {/* PRIMARY BAR – edge-to-edge */}
      <Box
        sx={{
          width: "100%",
          bgcolor: "primary.main",
          color:  "primary.contrastText",
          px: { xs: 4, md: 6 },          // ← exact same left/right padding
          py: { xs: 2, md: 3 },          // ← exact same top/bottom padding
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* centred icon + title group */}
        <Box
          sx={{
            mx: "auto",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            letterSpacing: ".05em",
          }}
        >
          
          <GTranslateIcon    fontSize="small" />

          <Typography variant="h4">{title}</Typography>

          <GTranslateIcon    fontSize="small" />
        </Box>

        {/* right-hand slot (buttons, toggles, etc.) */}
        {children && (
          <Stack direction="row" spacing={1}>
            {children}
          </Stack>
        )}
      </Box>

      {/* sub-header centred below bar */}
      {subHeader && (
        <Box
          sx={{
            maxWidth: 1280,
            mx: "auto",
            pt: 2,
            textAlign: "center",
            letterSpacing: ".05em",
          }}
        >
          <Text tag="h2" use="span" options={{ size: "text-md" }}>
            {subHeader}
          </Text>
        </Box>
      )}

      {/* divider exactly like simplified page */}
      <Divider sx={{ mt: 2, maxWidth: 1280, mx: "auto" }} />
    </>
  );
}

ImportHeader.propTypes = {
  title     : PropTypes.string.isRequired,
  subHeader : PropTypes.string,
  children  : PropTypes.node,
};

ImportHeader.defaultProps = {
  subHeader : null,
  children  : null,
};
